import Repository from './Repository';

const resource = '/customer';

export default {
  /**
   * 顧客情報
   */
  get(): Promise<{ id: string; attrs: any /** CustomerAttributes */; registered: boolean }> {
    return Repository.get(`${resource}`);
  },
};
